'use strict';

var EditWebFiltersTitanHq = require('actionGroups/webFiltersTitanHq/WebFiltersTitanHq');

module.exports = {
  Model: EditWebFiltersTitanHq,
};
